import React from 'react';
import { HubShell } from '../../components/hub/shell';
import ProfilePage from '../ProfilePage';

/**
 * Profile inside the ClientHub HubShell: opening the profile from the hub's
 * top-bar avatar keeps the page in the hub's own column (sidebar + top bar stay
 * in view), instead of dropping out to the legacy dashboard chrome. The
 * identical profile surface also renders in that dashboard chrome via
 * <ProfilePage variant="dashboard"> at /profile; both wrappers stay thin
 * because all the page logic lives in ProfilePage itself (mirrors EffortHubPage
 * vs EffortPage).
 */
export default function HubProfilePage() {
  return (
    <ProfilePage variant="hub" />
  );
}
